export function addProjectScopeToRoute(routeString, cstm) {
  if (!cstm) {
    throw Error('no cstm defined');
  }
  /**
   * @param string[] routeParameters
   * ['','api','route']
   */
  const routeParameters = routeString.split('/');
  routeParameters.splice(2, 0, cstm);
  const newRoute = routeParameters.join('/');
  return newRoute;
}
